import dayjs from 'dayjs';

export const convertDuration = (amount: number): string => {
  let result = '';
  const duration = dayjs.duration(amount, 'm');
  if (duration.hours() > 0) {
    result += duration.hours().toString().concat('h');
  }

  if (duration.minutes() > 0) {
    result +=
      duration.minutes() < 10
        ? '0' + duration.minutes().toString()
        : duration.minutes().toString();
    if (duration.hours() <= 0) {
      result += ' min';
    }
  }

  return result;
};

export const getTranslatableDuration = (
  immobilisationDuration: number
): { value: string; param: any } => {
  const usedDuration = immobilisationDuration ?? 90;
  const hour = Math.floor(usedDuration / 60);
  const min = usedDuration % 60;
  let minStr = min.toString();
  if (usedDuration < 60) {
    return {
      value: 'GlobalApplicativeConstants.time.interventionTimeInMinutes',
      param: { minStr },
    };
  }

  if (min === 0) {
    minStr = '';
    return {
      value: 'GlobalApplicativeConstants.time.interventionTimeInHours',
      param: { hour, minStr },
    };
  } else {
    if (min < 10) {
      minStr = `0${minStr}`;
    }
    return {
      value:
        'GlobalApplicativeConstants.time.interventionTimeInHoursAndMinutes',
      param: { hour, minStr },
    };
  }
};

/**
 * Resolve the effective intervention duration (in minutes) using the configuration
 * priority: config.defaultInterventionDuration[operation] -> appointmentDuration
 * If operation is not provided, config duration is ignored and appointmentDuration is used.
 */
export const resolveInterventionDuration = (
  config: any,
  operation?: string | undefined,
  appointmentDuration?: number | undefined
): number | undefined => {
  const configDuration = operation
    ? config?.defaultInterventionDuration?.[operation]
    : undefined;
  return configDuration ?? appointmentDuration;
};

export const isTimeBetween = (
  startTime: dayjs.ConfigType,
  endTime: dayjs.ConfigType,
  serverTime: dayjs.ConfigType
) => {
  const start = dayjs(startTime, 'H:mm');
  const end = dayjs(endTime, 'H:mm');
  const server = dayjs(serverTime, 'H:mm');
  if (end < start) {
    return (
      (server >= start && server <= dayjs('23:59:59', 'h:mm:ss')) ||
      (server >= dayjs('0:00:00', 'h:mm:ss') && server < end)
    );
  }
  return server >= start && server < end;
};
